export const COLORS = {
  black: '#15092C',
  white: '#FFF',
  brandPrimary: '#2C079F',
  brandSecondary: '#CA01E4',
  brandSecondaryDark: '#9A00A9',
  brandTertiary: '#00CFFF',
  backgroundPrimary: '#F4F3F2',
  grey200: '#CFCCD1',
};
